<template>
    <div>
        <RentalInfoShell/>
        <ActionBar :fixed="true" :style="{ 'height': '80px' }">
            <div class="container w-100">
                <div class="flex items-center justify-end">
                    <router-link class="no-underline w-50 w-30-m" to="/error-page">
                        <BlackButton >Get Directions</BlackButton>
                    </router-link>
                    <router-link class="no-underline w-50 w-30-m ml3 ml4-ns" to="/inbox">
                        <TooliabaButton >View Chat</TooliabaButton>
                    </router-link>
                </div>
            </div>
        </ActionBar>
    </div>
</template>

<script>
import RentalInfoShell from '@/components/rentalsListings/shared/RentalInfoShell';
import ActionBar from '@/components/global/ActionBar.vue';
import BlackButton from '@/components/buttons/BlackButton.vue';
import TooliabaButton from '@/components/buttons/TooliabaButton.vue';

export default {
    components: {
        RentalInfoShell,
        ActionBar,
        BlackButton,
        TooliabaButton
    }
};
</script>
